import './index.scss';

import React, { useEffect } from 'react';
import { CBTooltip} from '../../constants/apricotCBform';

const Tooltip = ({ tooltipid, tooltipMsg, innerMsg, className }) => {
  //classname is for sidebar glyph

  useEffect(() => {
    const tooltip = CBTooltip({
      elem: document.querySelector(`#${tooltipid}`),
      placement:'right',
      offset:[0,1],
      html:true
    });
    return () => {
      if (tooltip) {
        tooltip.destroy();
      }
    };
  }, [tooltipid, tooltipMsg]);

 
  const display = !className?
    <span id={tooltipid}
          tabIndex='0' role='link' aria-label={tooltipMsg}
          data-cb-title={tooltipMsg} className={className}>
            {innerMsg}
    </span>:
    <span id={tooltipid}
    tabIndex='-1' aria-label={tooltipMsg}
    data-cb-title={tooltipMsg} className={className}>
    {innerMsg}
    </span>;

  return display;
};

export default Tooltip;